
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import ApiClient from "@/utilities/ApiClient";
    import FileDownload from "@/utilities/FileDownload";
    import { Client } from "@/model/Client";
    import { DownloadOptions } from "@/model/pagePartOptions/DownloadOptions";

    @Component({})
    export default class DownloadPart extends Vue {

        missingImage = require("@/images/missing.png");

        @Prop({ default: new DownloadOptions() })
        options!: DownloadOptions;

        @Prop({ default: false })
        isAdminView!: boolean;

        // in admin view, this will be set according to briefing - otherwise will come from Vuex store (from URL)
        @Prop({ default: null })
        client!: Client|null;

        get colour(): string {
            const grey = "#888";
            if(!this.options.clientColourField) return grey;
            const client = this.client ?? this.$store.state.clientSettings?.client;
            if(!client) return grey;
            const field = this.options.clientColourField;
            if(!field) return grey;
            return client[field] ?? grey;
        }

        get resourceUrl(): string {
            return this.options.resource?.sourceUrl ?? require("@/images/missing.png");
        }

        get iconUrl(): string {
            if(!this.options.resource.hasFile) return ApiClient.resolveUrl("api/file/icon?extension=nul");
            const filename = this.options.resource.filename;
            const dotAt = filename.lastIndexOf(".");
            const extension = dotAt === -1 || dotAt >= filename.length - 1 ? "" : filename.substr(dotAt + 1).toLowerCase();
            return ApiClient.resolveUrl(`api/file/icon?extension=${extension}`);
        }

        async download() {
            FileDownload.download(this.options.resource);
        }

    }
